<template>
  <v-dialog v-if="show" v-model="show" persistent width="65%">
    <v-card class="py-2" color="cardbg">
      <v-card-title class="headline font-weight-bold black--text mb-3">
        <div>
          <h2 class="black--text">
            {{ $t("hfManagement.editStaffTableTitle") }}
          </h2>
        </div>
      </v-card-title>
      <v-card-text>
        <v-data-table
          mobile-breakpoint="0"
          :items="getDummyDimension()"
          hide-default-footer
        >
          <!-- NO DATA -->
          <template v-slot:no-data>
            <base-table-no-data
              message="hfManagement.emptyData"
            ></base-table-no-data>
          </template>

          <template v-slot:header>
            <thead>
              <tr class="table-header">
                <th
                  scope="col"
                  class="table-header-data body-1 text-no-wrap"
                ></th>
                <th scope="col" class="table-header-data body-1 text-no-wrap">
                  {{ $t("hfManagement.employee") }}
                </th>
                <th scope="col" class="table-header-data body-1 text-no-wrap">
                  {{ $t("hfManagement.freelancer") }}
                </th>
                <th scope="col" class="table-header-data body-1 text-no-wrap">
                  {{ $t("hfManagement.cooperative") }}
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:item>
            <!-- DOCTORS -->
            <tr class="table-content">
              <td
                class="table-content-label body-1 font-weight-bold text-no-wrap pl-2"
              >
                {{ $t("hfManagement.doctors") }}
              </td>
              <td class="table-content-data px-1">
                <v-text-field
                  v-model.number="dimension.numEmployedMedicalStaff"
                  :value="dimension.numEmployedMedicalStaff"
                  class="input-table-item"
                  :disabled="!isEditingStaffTable"
                  type="number"
                  min="0"
                  hide-details
                ></v-text-field>
              </td>
              <td class="table-content-data px-1">
                <v-text-field
                  v-model.number="dimension.numExternalMedicalStaff"
                  :value="dimension.numExternalMedicalStaff"
                  class="input-table-item"
                  :disabled="!isEditingStaffTable"
                  type="number"
                  min="0"
                  hide-details
                ></v-text-field>
              </td>
              <td class="table-content-data px-1"></td>
            </tr>
            <!-- NURSES -->
            <tr class="table-content">
              <td
                class="table-content-label body-1 font-weight-bold text-no-wrap pl-2"
              >
                {{ $t("hfManagement.nurses") }}
              </td>
              <td class="table-content-data px-1">
                <v-text-field
                  v-model.number="dimension.numEmployedNurseryStaff"
                  :value="dimension.numEmployedNurseryStaff"
                  class="input-table-item"
                  :disabled="!isEditingStaffTable"
                  type="number"
                  min="0"
                  hide-details
                ></v-text-field>
              </td>
              <td class="table-content-data px-1"></td>
              <td class="table-content-data px-1">
                <v-text-field
                  v-model.number="dimension.numExternalNurseryStaff"
                  :value="dimension.numExternalNurseryStaff"
                  class="input-table-item"
                  :disabled="!isEditingStaffTable"
                  type="number"
                  min="0"
                  hide-details
                ></v-text-field>
              </td>
            </tr>
            <!-- AUXILIARY -->
            <tr class="table-content">
              <td
                class="table-content-label body-1 font-weight-bold text-no-wrap pl-2"
              >
                {{ $t("hfManagement.auxiliary") }}
              </td>
              <td class="table-content-data px-1">
                <v-text-field
                  v-model.number="dimension.numEmployedAuxStaff"
                  :value="dimension.numEmployedAuxStaff"
                  class="input-table-item"
                  :disabled="!isEditingStaffTable"
                  type="number"
                  min="0"
                  hide-details
                ></v-text-field>
              </td>
              <td class="table-content-data px-1"></td>
              <td class="table-content-data px-1">
                <v-text-field
                  v-model.number="dimension.numExternalAuxStaff"
                  :value="dimension.numExternalAuxStaff"
                  class="input-table-item"
                  :disabled="!isEditingStaffTable"
                  type="number"
                  min="0"
                  hide-details
                ></v-text-field>
              </td>
            </tr>
            <!-- ADMINISTRATIVES -->
            <tr class="table-content">
              <td
                class="table-content-label body-1 font-weight-bold text-no-wrap pl-2"
              >
                {{ $t("hfManagement.administratives") }}
              </td>
              <td class="table-content-data px-1">
                <v-text-field
                  v-model.number="dimension.numEmployedFinancialStaff"
                  :value="dimension.numEmployedFinancialStaff"
                  class="input-table-item"
                  :disabled="!isEditingStaffTable"
                  type="number"
                  min="0"
                  hide-details
                ></v-text-field>
              </td>
              <td class="table-content-data px-1"></td>
              <td class="table-content-data px-1"></td>
            </tr>
            <!-- OTHER HEALTH PROFESSIONS -->
            <tr class="table-content">
              <td
                class="table-content-label body-1 font-weight-bold text-no-wrap pl-2"
              >
                {{ $t("hfManagement.otherHealthProfessions") }}
              </td>
              <td class="table-content-data px-1">
                <v-text-field
                  v-model.number="dimension.numEmployedOtherMedicalStaff"
                  :value="dimension.numEmployedOtherMedicalStaff"
                  class="input-table-item"
                  :disabled="!isEditingStaffTable"
                  type="number"
                  min="0"
                  hide-details
                ></v-text-field>
              </td>
              <td class="table-content-data px-1">
                <v-text-field
                  v-model.number="dimension.numExternalOtherMedicalStaff"
                  :value="dimension.numExternalOtherMedicalStaff"
                  class="input-table-item"
                  :disabled="!isEditingStaffTable"
                  type="number"
                  min="0"
                  hide-details
                ></v-text-field>
              </td>
              <td class="table-content-data px-1"></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-row class="no-gutters px-3">
          <v-col class="ml-auto col-auto">
            <v-btn
              v-if="isEditingStaffTable && hasWritePerm"
              class="caption font-weight-bold"
              color="primary"
              rounded
              depressed
              @click="saveTable"
              >{{ $t("saveButton") }}</v-btn
            >
            <v-btn
              class="caption font-weight-bold"
              color="primary"
              rounded
              depressed
              @click="show = false"
              >{{ $t("closeButton") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import isEmpty from "lodash/isEmpty";

export default {
  props: {
    officeId: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    hasWritePerm: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.isEditingStaffTable = false;
        this.$store.commit("doctors/RESET_MODIFIED_DIMENSION");
        this.dimension = { ...this.$store.getters["doctors/editedDimension"] };
      }
    }
  },
  data() {
    return {
      isEditingStaffTable: false,
      dimension: {}
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  created() {},
  methods: {
    editTable() {
      this.isEditingStaffTable = !this.isEditingStaffTable;
    },
    saveTable() {
      this.isEditingStaffTable = !this.isEditingStaffTable;
      this.$store
        .dispatch("doctors/setDimension", {
          officeId: this.officeId,
          dimension: this.dimension
        })
        .then(() => {})
        .catch(() => {})
        .finally(() => {});
    },
    getDummyDimension() {
      return !isEmpty(this.dimension) ? [{}] : [];
    },
    isDimensionEmpty() {
      return isEmpty(this.dimension);
    }
  }
};
</script>

<style scoped>
.v-data-table .table-header {
  background-color: var(--primary);
}
.v-data-table .table-header th {
  color: white !important;
  text-align: center !important;
  font-size: 14px;
  padding: 0px;
  white-space: normal !important;
}

.table-content-label {
  height: 30px !important;
}

.table-content-data {
  text-align: center;
  height: 30px !important;
}

.table-content-data >>> .input-table-item {
  margin: 0 auto;
  padding: 0;
  width: 50%;
}

.table-content-data >>> .input-table-item .v-text-field__slot input {
  text-align: center;
  font-size: small;
  padding: 0;
}

.table-content-data
  >>> .input-table-item.v-input--is-disabled
  .v-input__slot::before {
  border-style: unset;
}

.table-content-data
  >>> .input-table-item.v-input--is-disabled
  .v-text-field__slot
  input {
  color: black;
  -moz-appearance: textfield;
}
</style>
